export default "__VITE_ASSET__f5c6b4a8__"